import {
  AppContext,
  getTranslatedText,
  useUserMSPCheckHook
} from '@nile/components';
import {
  Button,
  ButtonGroup,
  TextField,
  Heading,
  Banner
} from '@superops/ui-design-system';
import { SelectUsers } from '@nile/mangifera/src/Pebbles/ChatContainer';
import React, { useState, useContext } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { AccountClient, GET_CLIENT_USER_LIST } from '@nile/graphql';

const SignatureHolder = styled.div`
  border: 1px solid #ececec;
  border-radius: 10px;
  margin-top: 10px;
  input {
    height: 30px;
    border-bottom: ${(props) =>
      props.hideSignature ? 'none !important' : '1px solid #ececec'};
    padding-left: 5px;
  }
`;
const TextContainer = styled.div`
  .Superops-TextField--multiline {
    padding-left: 10px;
    min-height: 38px;
    display: flex;
    flex-grow: 1;
    background: transparent;
    border: 1px solid #ececec;
    border-radius: 10px;
    height: 100px;
    overfow: auto;
  }
  textarea {
    height: 100% !important;
    border-bottom: none !important;
  }
`;

const SignatureDisplayContainer = styled.div`
  font-size: 60px;
  font-weight: 700;
  padding: 9px 15px;
  line-height: 60px;
  min-height: 100px;
  line-break: anywhere;
  font-family: 'Qwitcher Grypen', cursive;
  align-self: flex-start;
  &.empty {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    color: #a3a3a3;
  }
`;

function QuoteActionPopup(props) {
  const { nonAuthenticated, hideSignature } = props;
  const isMSP = useUserMSPCheckHook();
  const restrictUserDropdown = !isMSP || nonAuthenticated;
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user;
  const currentUserObject =
    currentUser && !isMSP
      ? { ...currentUser, label: currentUser.name, value: currentUser.name }
      : null;
  const [user, setUser] = useState(isMSP ? null : currentUserObject || null);
  const [comments, setComments] = useState(null);
  const [signature, setSignature] = useState(null);
  const {
    intl,
    closeModal,
    client,
    isLoading,
    meta,
    showEmail,
    bannerInfo
  } = props;
  const { title, commentsHeader, commentsPlaceholder } = meta;
  const updateField = (val) => {
    setUser(val);
  };

  const generateOptions = (userData) => {
    let users = userData || [];
    users = users?.map((el) => {
      el = el.user;
      return {
        ...el,
        label: `${el.name} ${showEmail ? ` <${el.email}>` : ''}`,
        value: `${el.name}`
      };
    });
    return users;
  };
  const handleSubmit = () => {
    props.handleSubmit({
      user: user,
      comments: comments
    });
  };

  return (
    <div className="bg-white rounded-2xl p20 ">
      <Heading>
        <FormattedMessage id={title} />
      </Heading>
      {bannerInfo && (
        <div className="mt-10">
          <Banner status="info">
            <FormattedMessage id={bannerInfo} />
          </Banner>
        </div>
      )}
      <div className="fg1">
        {!restrictUserDropdown ? (
          <SelectUsers
            updateField={updateField}
            property="userId"
            query={GET_CLIENT_USER_LIST}
            params={{
              client: AccountClient,
              variables: {
                input: {
                  clientId: client.accountId,
                  listInfo: {
                    sort: {
                      attribute: 'user.name',
                      order: 'ASC'
                    }
                  }
                }
              }
            }}
            methodName="getClientUserAssociationsList"
            generateOptions={generateOptions}
            field="to"
            value={user}
            selectedValue={user}
            // creatable
            fetchBefore
          />
        ) : (
          <SignatureHolder
            className="flex col center"
            hideSignature={hideSignature}
          >
            <TextField
              size="medium"
              fontSize="default"
              customClassName="Role-Description"
              placeholder={getTranslatedText(
                intl,
                'quote.actionPopup.enterUserName'
              )}
              value={user?.name}
              onChange={(val) => {
                updateField({ ...user, name: val });
              }}
            />
            {!hideSignature && (
              <SignatureDisplayContainer>
                {user?.name ||
                  getTranslatedText(
                    intl,
                    'quote.actionPopup.signature.placeholder'
                  )}
              </SignatureDisplayContainer>
            )}
          </SignatureHolder>
        )}
      </div>
      <TextContainer className="mt-20">
        <TextField
          multiline
          size="medium"
          fontSize="default"
          label={commentsHeader}
          customClassName="Role-Description"
          placeholder={commentsPlaceholder}
          value={comments}
          onChange={(val) => {
            setComments(val);
          }}
        />
      </TextContainer>
      <div className="mt-20 flex jend">
        <ButtonGroup>
          <Button primary loading={isLoading} onClick={handleSubmit}>
            <FormattedMessage id="app.actions.submit" />
          </Button>
          {/* <Button plainSecondary onClick={() => setModalActive(false)}>
            <FormattedMessage id="Cancel" />
          </Button> */}
        </ButtonGroup>
      </div>
    </div>
  );
}

export default injectIntl(QuoteActionPopup);
